<script>
import {defineComponent} from 'vue'
import ApiRequest from "@/core/api-request";
import SelectBox from "@/components/layout/form_inputs/SelectBox.vue";
import Alert from "@/components/layout/Alert";
import SelectBoxServer from "@/components/layout/form_inputs/SelectBoxServer.vue";
import ListMawbsModal from "@/components/pages/checkout/ListMawbsModal.vue";

export default defineComponent({
  name: "CheckOutIndex",
  components: {ListMawbsModal, SelectBoxServer, SelectBox},
  data() {
    return {
      truck: null,
      mawbs: [],
      check_at: this.$moment(new Date()).format('YYYY-MM-DD HH:mm:SS'),
      routes: [
        {id: 'ASG-NCTS', name: 'ASG-NCTS'},
        {id: 'ASG-ACSV', name: 'ASG-ACSV'},
        {id: 'ASG-ALSC', name: 'ASG-ALSC'}
      ],
      data: {
        TruckNo: null,
        SealNo: null,
        Route: null,
        DP_Datetime: null,
        list_mawb: []
      }
    }
  },
  methods: {
    clear() {
      this.data = {
        TruckNo: null,
        SealNo: null,
        Route: null,
        DP_Datetime: null,
        list_mawb: []
      }
      this.check_at = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:SS');
    },
    submit() {
      let data = {...this.data};
      data.DP_Datetime = this.$moment(this.check_at).format('YYYY-MM-DD HH:mm');
      ApiRequest.post({uri: '/check-out', data: data}).then(() => {
        Alert.success({message: 'Xử lý thành công'});
        this.clear();
      }).catch((e) => {
        console.error(e)
      });
    },
    removeMawb(mawb) {
      const index = this.data.list_mawb.findIndex(item => item.Mawb === mawb.Mawb);
      if (index > -1) {
        this.data.list_mawb.splice(index, 1);
      }
    }
  }
})
</script>

<template>
  <div class="px-4">
    <h4 class="text-orange">Check Out</h4>
    <div class="form-group">
      <label>Xe</label>
      <SelectBoxServer :multiple="false" ref="sle_customer"
                       required
                       v-model="data.TruckNo"
                       v-model:modelObject="truck"
                       :value-field="'Id'"
                       :displayField="'Truck_No'"
                       :search-field="'search'"
                       :options="{url:'/trucks',resourceKey:'trucks'}"/>
    </div>
    <div class="form-group">
      <label>Tuyến</label>
      <select-box :options="routes" :display-field="'name'" :value-field="'id'" v-model="data.Route"></select-box>
    </div>

    <div class="form-group">
      <label>Seal</label>
      <input type="text" v-model="data.SealNo" class="form-control">
    </div>

    <div class="form-group">
      <label>Ngày giờ</label>
      <input type="datetime-local" class="form-control" v-model="check_at">
    </div>
    <div class="form-group">
      <div class="py-2 d-flex">
        <button class="btn btn-primary ml-auto" @click="$refs.list_mawbs_modal.show()">Chọn Mawb <i
            class="fal fa-plus"></i></button>
      </div>

      <div class="border rounded" style="max-height: 50vh; overflow-y: auto">
        <table class="table table-head-fixed text-nowrap">
          <thead>
          <tr>
            <th></th>
            <th>Mawb</th>
            <th>Total</th>
            <th width="100px">Pcs</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="mawb in data.list_mawb" :key="mawb.Mawb">
            <tr>
              <td>
                <button class="btn btn-link btn-sm" @click="removeMawb(mawb)"><i
                    class="fas fa-lg fa-times-circle text-danger"></i></button>
              </td>
              <td><b class="mr-2 text-info">{{ mawb.Mawb }}</b></td>
              <td>{{ mawb.Pcs_Total }}</td>
              <td><input type="number" class="form-control form-control-sm" :max="mawb.Pcs_Remain" v-model="mawb.Pcs">
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>

    <div class="py-2">
      <button class="btn btn-success w-100" @click="submit">Xác nhận</button>
    </div>
  </div>
  <list-mawbs-modal ref="list_mawbs_modal" v-model:selected_mawb="data.list_mawb"/>
</template>

<style scoped>

</style>